import { Injectable, Renderer2 } from '@angular/core';
import { AnalyticsData, AnalyticsService } from '@icullen/api/shared';

@Injectable({
  providedIn: 'root',
})
export class AudioEventService {
  constructor(private analyticsService: AnalyticsService) {}

  addEventListeners(container: any, renderer: Renderer2, docData: any) {
    const audios = container.nativeElement.getElementsByTagName('audio');
    // This is gonna our percent buckets ( 10%-90% )
    const divisor = 10;
    // We're going to save our players status on this object.
    const audios_status = {};

    for (let i = 0; i < audios.length; i++) {
      let audioTagId;
      if (!audios[i].getAttribute('id')) {
        // Generate a random alphanumeric string to use is as the id
        audioTagId = 'html5_audio_' + Math.random().toString(36).slice(2);
        audios[i].setAttribute('id', audioTagId);
      } // Current audio has alredy a id attribute, then let's use it ?
      else {
        audioTagId = audios[i].getAttribute('id');
      }
      // audio Status Object declaration
      audios_status[audioTagId] = {};
      // We'll save the highest percent mark played by the user in the current audio.
      audios_status[audioTagId].greatest_marker = 0;
      // Let's set the progress markers, so we can know afterwards which ones have been already sent.
      audios_status[audioTagId]._progress_markers = {};
      for (let j = 0; j < 100; j++) {
        audios_status[audioTagId].progress_point =
          divisor * Math.floor(j / divisor);
        audios_status[audioTagId]._progress_markers[
          audios_status[audioTagId].progress_point
        ] = false;
      }
      // On page DOM, all players currentTime is 0
      audios_status[audioTagId].current = 0;
      const element = audios[i];
      //element.addEventListener('play',this.eventHandler('play'),false);
      renderer.listen(element, 'play', (event) => {
        const pctCompleted = Math.floor(
          (100 * audios_status[event.target.id].current) / event.target.duration
        );
        this.analyticsService.pushAudioAnalyticsData(
          event,
          pctCompleted,
          docData
        );
      });
      renderer.listen(element, 'pause', (event) => {
        const pctCompleted = Math.floor(
          (100 * audios_status[event.target.id].current) / event.target.duration
        );
        this.analyticsService.pushAudioAnalyticsData(
          event,
          pctCompleted,
          docData
        );
      });
      renderer.listen(element, 'ended', (event) => {
        this.analyticsService.pushAudioAnalyticsData(event, 100, docData);
      });
      renderer.listen(element, 'timeupdate', (e) => {
        // Let's set the save the current player's audio time in our status object
        audios_status[e.target.id].current = Math.round(e.target.currentTime);
        // We just want to send the percent events once
        const pct = Math.floor(
          (100 * audios_status[e.target.id].current) / e.target.duration
        );
        const progressMarkers: number[] = Object.keys(
          audios_status[e.target.id]._progress_markers
        ).map(Number);
        for (const j of progressMarkers) {
          if (pct >= j && j > audios_status[e.target.id].greatest_marker) {
            audios_status[e.target.id].greatest_marker = j;
          }
        }
        // current bucket hasn't been already sent to GA?, let's push it to GTM
        if (
          audios_status[e.target.id].greatest_marker &&
          !audios_status[e.target.id]._progress_markers[
            audios_status[e.target.id].greatest_marker
          ]
        ) {
          audios_status[e.target.id]._progress_markers[
            audios_status[e.target.id].greatest_marker
          ] = true;
          this.analyticsService.pushAudioAnalyticsData(
            e,
            audios_status[e.target.id].greatest_marker,
            docData
          );
        }
      });
    }
  }
}
